import React from 'react';
import PropTypes from 'prop-types';

import { SpacerVertical, Typography } from '@klarna/bubble-ui';

import { ValueItem } from './ValueItem';
import { LinkWithoutHref } from '@/components';

type ValueListProps = {
  clearLabel: string;
  label: string;
  onChange: (value: string[]) => void;
  options: { key: string; label: string }[];
  value: string[];
};

export const ValueList = ({
  clearLabel,
  label,
  onChange = () => {},
  options = [],
  value = [],
}: ValueListProps): JSX.Element => {
  const toggle = key =>
    onChange(value.includes(key) ? value.filter(k => k !== key) : [...value, key]);

  const clear = () => onChange([]);

  const selectedOptions = value.map(v => options.find(o => o.key === v)).filter(option => !!option);

  return selectedOptions && selectedOptions.length > 0 ? (
    <>
      <Typography
        textToken="text-style/text/super-paragraphs/body/medium"
        colorToken="colors/text/neutral"
      >
        {label}
      </Typography>

      <SpacerVertical spaceToken="space/150" />

      {selectedOptions.map(({ key, label, ...rest }) => (
        <ValueItem key={key} itemKey={key} label={label} onClick={() => toggle(key)} {...rest} />
      ))}

      {clearLabel && (
        <>
          <SpacerVertical spaceToken="space/150" />
          <LinkWithoutHref isUnderlined colorToken="colors/text/neutral" onPress={clear}>
            {clearLabel}
          </LinkWithoutHref>
        </>
      )}
    </>
  ) : (
    <></>
  );
};

ValueList.propTypes = {
  clearLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.array,
};
